import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
/**
 * Component that to track outside Profile div click
 */
@connect(state => ({
  showProfileFlag:state.dashboardRoot.dashboardReducer.showProfileFlag,
}), {
  ...dashboardActions,
  ...commonActions
})

export default class OutsideAlerter extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  static propTypes = {
    setShowProfileFlag:PropTypes.func,
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    try{
      this.wrapperRef = node;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setWrapperRef', component:"OutsideAlerter"});
    }
  }

  /**
   * UPDATE PROPS
   */
  handleClickOutside(event) {
    try{
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
          // console.log(this.wrapperRef);
          this.wrapperRef.style.display='none';
          this.props.setShowProfileFlag(false);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleClickOutside', component:"OutsideAlerter"});
    }
  }

  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};
